export default __webpack_public_path__ + "static/media/my-health.3bec6162.svg";